import { DollarSign } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { ProductCustomerPricingPage } from './pages/ProductCustomerPricingPage'

/**
 * Product Customer Pricing — per-customer, per-product pricing &
 * margin visibility. Read-only: "for this product, what does each
 * customer pay per kg/lb and what margin am I making" — informs
 * pricelist-onboarding and price-setting decisions but does not write
 * anything itself. MasterDetail archetype (product list left,
 * customer breakdown right), mirroring Customer Pricelists.
 */
export default defineModule({
  id: 'product-customer-pricing',
  name: 'Product Customer Pricing',
  shortName: 'Customer Pricing',
  icon: DollarSign,
  navSection: 'sales',
  navOrder: 45,
  urlNamespace: '/customer-product-pricing',
  routes: [
    { path: '/', element: ProductCustomerPricingPage, label: 'Product Customer Pricing' },
  ],
  permissions: ['admin', 'sales', 'finance'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g c p',

  commandPaletteEntries: [
    {
      label: 'Go to Product Customer Pricing',
      keywords: ['pricing', 'margin', 'customer', 'product', 'per kg', 'per lb'],
      path: '/',
      group: 'modules',
      shortcut: 'g c p',
    },
  ],

  consumesServices: ['odoo-search'],
})
